import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

import logo from "../../Assets/log-out 1.svg";
import logout from "../../Assets/logout.svg";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PathList from "../../Common/PathList";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 12,
  p: 4,
  borderRadius: "35px",
  outline: "none",
};

export default function LogoutModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    handleClose();
    navigate(PathList._Login);
    toast.success("Logout successfully.", { toastId: "logout" });
  };

  return (
    <div>
      <Box
        className={"flexCenter"}
        sx={{
          px: 1,
        }}
      >
        <ListItem
          disablePadding
          onClick={handleOpen}
          sx={{
            padding: "0 0.5rem",
            borderRadius: "12px",
            background: "#164FA1",
            color: "#fff",
            "&:hover": {
              background: "#F57C00",
            },
          }}
        >
          <ListItemButton>
            <ListItemIcon>
              <img
                src={logout}
                style={{ height: "24px", width: "24px", objectFit: "cover" }}
                alt="Icon"
                srcSet=""
              />
            </ListItemIcon>
            <ListItemText primary={"Logout"} />
          </ListItemButton>
        </ListItem>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box className={"flexCenter"}>
            <img
              src={logo}
              style={{
                height: "100px",
                width: "100px",
                objectFit: "cover",
                borderRadius: "50%",
              }}
              alt="Icon"
              srcSet=""
            />
          </Box>
          <Typography
            sx={{
              fontSize: "25px",
              fontWeight: 700,
              textAlign: "center",
              paddingTop: "0.7rem",
            }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Logout Confirmation
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              padding: "0.7rem 0",
              fontSize: "18px",
              color: "#6B6969",
            }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Are you sure you want to logout?
          </Typography>
          <Box
            className={"flexCenter"}
            sx={{ justifyContent: "space-between", gap: "1rem" }}
          >
            <Button
              variant="outlined"
              sx={{
                width: "100%",
                textTransform: "none",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
              onClick={handleClose}
            >
              Cancle
            </Button>
            <Button
              variant="outlined"
              sx={{
                width: "100%",
                textTransform: "none",
                borderRadius: "8px",
                backgroundColor: "#164FA1",
                color: "white",
                "&:hover": {
                  backgroundColor: "#164FA1",
                  color: "white",
                },
              }}
              onClick={handleLogout}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
